export default __webpack_public_path__ + "static/media/img-0465-montenegro-premium-face.dc36d733.png";